import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { createReducers } from '../reducers'
import rootSaga from '../sagas'
import history from '../routes/history'
import { routerMiddleware } from 'connected-react-router'
// import { loadState, saveState } from '../utils/localStorage'

const sagaMiddleware = createSagaMiddleware()

const middlewares = [
  routerMiddleware(history),
  sagaMiddleware
]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const persistedState = {} //loadState();

const store = createStore(
  createReducers(history),
  persistedState,
  composeEnhancers(
    applyMiddleware(
      ...middlewares
    )
  )
)

// store.subscribe(() => {
//   saveState({
//     loadMenuDataReducers: store.getState().loadMenuDataReducers
//   });
// });


sagaMiddleware.run(rootSaga)

export { store }
